import styled from 'styled-components';
import { device } from '../../../lib/media-query';
import { CheckBox } from '../../shared';

export const CalculationsContainer = styled.div`
    margin: 0 24px;
    padding: 16px;
    background-color: #f7f7f8;
    border-radius: 4px;

    @media ${device.mobile_tablet} {
        padding: 24px;
    }
`;

export const CalculatorSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 23px;
`;

export const SliderContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 9px;
`;

export const LabelAndValue = styled.div`
    display: flex;
    gap: 4px;
`;

export const Label = styled.label<{ bold?: boolean }>`
    color: #0b0b0b;
    font-size: 14px;
    font-weight: ${(props) => (props.bold ? 600 : 400)};
    letter-spacing: 0;
    margin-bottom: 9px;
`;

export const ErrorText = styled.p`
    color: #0b0b0b;
    letter-spacing: 0;
    font-weight: normal;
    margin-bottom: 20px;
`;

export const StyledAddOnsSection = styled.div`
    margin-top: 32px;
    background-color: white;
    border-radius: 4px;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
    display: flex;
    padding: 16px 20px 20px 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
`;

export const StyledAddOnsHeader = styled.p`
    font-size: 12px;
    font-weight: 600;
`;

export const StyledAddOnsOptionsGrid = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-self: stretch;
`;

export const StyledAddOnOption = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 12px;

    gap: 12px;
    border-bottom: 1px solid rgba(11, 11, 11, 0.1);
    align-self: stretch;
    justify-content: space-between;
    min-height: 41px;
    flex-wrap: wrap;
    padding-left: 35px;

    @media ${device.mobileL} {
        flex-direction: row;
        align-items: center;
    }

    @media ${device.laptop} {
        flex-direction: column;
        align-items: flex-start;
    }

    @media ${device.laptopS} {
        flex-direction: row;
        align-items: center;
    }

    label span {
        font-size: 14px;
        font-weight: 400;
    }
`;

export const StyledCheckbox = styled(CheckBox)`
    margin-left: -35px;
`;

export const StyledAddOnOptionPrice = styled.span`
    display: flex;
    gap: 12px;
    align-items: center;
`;

export const StyledAddOnOptionLink = styled.span`
    display: flex;
    gap: 12px;
    align-items: center;
    order: 1;
    width: 100%;

    @media ${device.mobile_tablet} {
        order: 0;
        width: auto;
        flex: 1;
        justify-content: flex-end;
        margin-right: 40px;
    }

    @media ${device.laptop} {
        order: 0;
        width: auto;
        flex: 1;
        justify-content: flex-end;
        margin-right: 40px;
    }

    @media ${device.laptopS} {
        margin-right: 20px;
    }

    button {
        margin-bottom: 4px;
        font-weight: 400;
    }
`;
